import React from 'react';
import { observer } from 'mobx-react';
import { Icon } from 'components/Icon';
import { Select, MultiSelect } from 'components/Select';
import { SearchInput } from 'components/SearchInput';
import pageStore from 'stores/Page/Integrations/IntegrationsPageStore';

import * as utils from 'Utils';
import * as constants from 'Constants';
import './styles.scss';


@observer
class IntegrationsFilter extends React.Component {
  constructor (props) {
    super(props);
  }

  render() {
    return (
      <div className="integrations-filter">
        <div className="integrations-filter-row">
          <div className="integrations-filter-label">Search</div>
          <SearchInput
            onChange={(value) => this.props.handleKeywordFilter(value)}
            value={pageStore.paramKeyword || ''}
          />
        </div>

        <div className="integrations-filter-row">
          <div className="integrations-filter-label">Category</div>
          <MultiSelect
            placeholder="Select categories"
            value={pageStore.paramCategories.slice()}
            options={pageStore.categorySelectOptions}
            onChange={(values) => this.props.handleFilter({"paramCategories": values})}
          />
        </div>

        <div className="integrations-filter-row">
          <div className="integrations-filter-label">Integrated Apps</div>
          <MultiSelect
            placeholder="Select integrated apps"
            value={pageStore.paramIntegratedApps.slice()}
            options={pageStore.integratedAppSelectOptions}
            onChange={(values) => this.props.handleFilter({"paramIntegratedApps": values})}
          />
        </div>
      </div>
    );
  }
}

export default IntegrationsFilter;
